<template>
  <div class="hotel-action-page">

    <div>
      <hotel-form :gurudwara-id="computedGurudwaraId" :hotel-id="computedHotelId" :is-edit-mode="computedIsEditMode"
        @saved="handleSaved" @cancelled="handleBackClick" />
    </div>
  </div>
</template>

<script>
import HotelForm from './HotelForm.vue'

export default {
  name: 'HotelActionPage',
  components: {
    HotelForm
  },
  props: {
    gurudwaraId: {
      type: String,
      default: null
    },
    hotelId: {
      type: String,
      default: null
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // Fallback to route params if props are not provided (for backward compatibility)
    computedGurudwaraId() {
      return this.gurudwaraId || this.$route.params.gurudwaraId
    },
    computedHotelId() {
      return this.hotelId || this.$route.params.hotelId || this.$route.params.id
    },
    computedIsEditMode() {
      return this.isEditMode || !!this.computedHotelId
    }
  },
  methods: {
    /**
     * Cancel: close modal parent if any; navigate when opened as a full route (/hotel/add, /hotel/:id/edit, etc.).
     */
    handleBackClick() {
      this.$emit('close')
      this.navigateAfterHotelFormClose()
    },
    /** Publish / save draft success */
    handleSaved() {
      this.$emit('close')
      this.$emit('saved')
      this.navigateAfterHotelFormClose()
    },
    navigateAfterHotelFormClose() {
      const n = this.$route.name
      if (n === 'create-hotel-global' || n === 'edit-hotel-global') {
        this.$router.push('/hotel/list')
        return
      }
      if (n === 'add-hotel' || n === 'edit-hotel') {
        const gwId = this.computedGurudwaraId
        if (gwId) {
          this.$router.push({
            path: `/gurudwara/${  gwId  }/edit`,
            query: { tab: 'hotel' }
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.hotel-action-page {
  min-height: 100vh;
  background: #f5f5f5;
}
</style>
